const ES = {
  company: [
    "sociedad limitada unipersonal (SLU)",
    "sociedad de responsabilidad limitada (SRL)",
    "sociedad cooperativa (S. Coop.)"
  ],
  legalArrangement: [
    "sociedad civil",
    "sociedad limitada laboral (SLL)",
    "asociación"
  ],
  soleProprietorship: [
    "empresario individual"
  ]
};
export {
  ES as default
};
